<div class="table-container">
    <mat-toolbar color="secondary">
        <mat-toolbar-row>
            <h1>My Profile</h1>
        </mat-toolbar-row>
    </mat-toolbar>
    <div style="display: flex; flex-direction: row; margin-left:100px;">
        <div class="avatar" style="transform: scale(2); margin: 50px;">{{ globalUser.getUser().usr_NAME.charAt(0).toUpperCase() }}</div>
        <div style="display: flex; flex-direction: column;">
            <p>Name: {{ user.usr_NAME }}</p>
            <p>Mail: {{ user.usr_MAIL }}</p>
            <p>Organization: {{ user.org_name}}</p>
            <p> Permissions:</p>
            <div style="display: flex;">
                <p *ngFor="let permission of user.permissions" style="margin: 5px;">{{permission}}</p>
            </div>
        </div>
    </div>

        
    <mat-toolbar color="secondary">
        <mat-toolbar-row>
            <h1>My Settings</h1>
        </mat-toolbar-row>
    </mat-toolbar>
     <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
        Coming soon!
    </div>
</div>